import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Order } from '../../../models/order.model';
import * as fromStore from '../../../store';
import { OrderState } from '../../../store/reducers/orders.reducer';

@Component({
  selector: 'app-orders-top',
  templateUrl: 'orders-top.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OrdersTopComponent implements OnInit {
  private orderStore = inject(Store<OrderState>);

  private store = inject(Store<fromStore.State>);

  private router = inject(Router);

  activeOrders$: Observable<Order[]>;

  totalActiveLocations$: Observable<number>;

  iconDetail = 'assignment';

  browserSize$: Observable<string> = this.store.select(
    fromStore.getBrowserSizeName,
  );

  browserSize: string;

  orderResCurr: any;

  private readonly destroyRef = inject(DestroyRef);

  private largeScreenInitialized = false;

  ngOnInit(): void {
    this.browserSize$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((name) => {
        if (name) {
          if (name !== this.browserSize && this.browserSize === 'small') {
            this.router.navigateByUrl('/orders');
          }
          this.browserSize = name;

          if (this.browserSize !== 'small') {
            this.onLargeScreen();
          }
        }
      });
  }

  onLargeScreen(): void {
    if (this.largeScreenInitialized) return;
    this.largeScreenInitialized = true;

    this.activeOrders$ = this.orderStore.select(fromStore.getActiveOrders);

    this.activeOrders$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((orders) => {
        if (orders) {
          const orderMap = new Map();
          orders.forEach((order) => {
            const count = orderMap.get(order.Status__c) || 0;
            orderMap.set(order.Status__c, count + 1);
          });
          const orderRes = [...orderMap].reduce((acc, curr) => {
            if (acc.length === 0) {
              acc.push({ [curr[0]]: curr[1] });
            } else {
              acc[0][curr[0]] = curr[1];
            }
            return acc;
          }, []);
          this.orderResCurr = orderRes[0];
        }
      });

    this.totalActiveLocations$ = this.orderStore.select(
      fromStore.getTotalActiveLocations,
    );
  }
}
